import { useMutation, type MutationHookOptions } from "@apollo/client"
import mutation from "@/v2-backoffice-client/invitation/resend/invitation.resend.mutation.gql"
import type {
  InvitationResendMutation,
  InvitationResendMutationVariables,
} from "@/v2-backoffice-client/invitation/resend/__types__/invitation.resend.mutation"

type Options = MutationHookOptions<
  InvitationResendMutation,
  InvitationResendMutationVariables
>

export function useInvitationResendMutation(options?: Options) {
  return useMutation<
    InvitationResendMutation,
    InvitationResendMutationVariables
  >(mutation, options)
}
